import actions from '@/store/modules/usersManagement/employees/actions';
import mutations from '@/store/modules/usersManagement/employees/mutations';

const state = {
  employees: [],
  isLoading: false,
  paginationInfo: {
    pageNumber: 1,
    pageSize: 5,
    sortBy: null,
    sortOrder: 'desc',
  },
  filterQuery: '',
  employeesTotal: 0,
  roles: [],
  managers: [],
  clients: [],
};

// getters
const getters = {

};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
